import { useState } from "preact/hooks";
import { feel } from "../feel/kit.js";
import { AT, useMoment } from "../moments/moments.js";
import type { Feat } from "./feats.js";

/**
 * What a play earned (ADR 0043, P5-LOOP-03): each achievement once, on the result, solo and in
 * rooms. Kept in Your Obean after that.
 */
export function FeatsEarned({ earned }: { earned: readonly Feat[] }) {
  // Moments (P5-UX-03): an achievement gets its sound, once, after the beans.
  const [shown, setShown] = useState(false);
  useMoment(
    earned.length > 0
      ? [
          {
            at: AT.feats,
            run: () => {
              setShown(true);
              feel("unlock");
            },
          },
        ]
      : [],
  );
  if (earned.length === 0) return null;
  return (
    <div class={`feats-earned${shown ? " shown" : ""}`} aria-live="polite">
      <p class="feats-title">{earned.length === 1 ? "Achievement" : "Achievements"}</p>
      <ul>
        {earned.map((f) => (
          <li key={f.key}>
            <span class="feat-mark" aria-hidden="true">
              ★
            </span>
            <strong>{f.name}</strong> <span class="feat-about">{f.about}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
